// wallets and koilib report errors as Error objects, plain strings or JSON strings
const errorText = (error) => {
  if (!error) return "";
  if (typeof error === "string") return error;
  return [error.message, error.error, error.reason].filter(Boolean).join(" ") || String(error);
};

const KNOWN_ERRORS = [
  { pattern: /reject|cancel|denied|declined/i, message: "Transaction cancelled in the wallet" },
  { pattern: /insufficient rc|not enough rc|mana/i, message: "Not enough mana to send this transaction" },
  { pattern: /revert/i, message: "The contract reverted the transaction" },
  { pattern: /time ?out/i, message: "The network did not answer in time, try again" },
];

/**
 * Human readable message for a transaction error, or the fallback when it is not a known one
 */
export const getErrorMessage = (error, fallback = "Error sending transaction") => {
  const text = errorText(error);
  const known = KNOWN_ERRORS.find(({ pattern }) => pattern.test(text));
  return known ? known.message : fallback;
};
